import { message } from "antd"; 

const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const getIdFromTime = ():string =>{
    // 获取当前的纳秒时间
    let nanoTime = process.hrtime.bigint();
    let result = '';
    for (let i = 0; i < 4; i++) {
        const index = nanoTime % BigInt(chars.length);
        result = chars[Number(index)] + result;
        nanoTime = BigInt(Math.floor(Number(nanoTime / BigInt(chars.length))));
    }
    return result;
} 

const stringCompareTo =  (a:string, b:string):number=>{
  if(a == b){
    return 0;
  }
  if(a && !b){
    return 1
  }
  else if (!a&&b){
    return -1;
  }
  if(a!=null && b != null){
    return a.localeCompare(a, b)
  }
  return 0;
}

const numberCompareTo =  (a: number, b:number):number=>{
  if(a == b){
    return 0;
  }
  if(a && !b){
    return 1
  }
  else if (!a&&b){
    return -1;
  }
  
  if(a!=null && b != null){
    return a - b;
  } 
  return 0;
}

const booleanCompareTo =  (a: boolean, b:boolean):number=>{
  if(a == b){
    return 0;
  }
  if(a && !b){
    return 1
  }
  else{
    return -1;
  }
}

const copyToClipboard = async (text: string) => {
  const fallbackCopy = (): boolean => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch {
      ok = false;
    }
    document.body.removeChild(textarea);
    return ok;
  };

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else if (!fallbackCopy()) {
      throw new Error('clipboard unavailable');
    }
    message.success('复制成功！');
  } catch (err) {
    if (fallbackCopy()) {
      message.success('复制成功！');
      return;
    }
    console.error('复制失败:', err);
    message.error('复制失败，请重试。');
  }
};

const getFullDateReadableTime = (date: Date): string => {
  if (!date) return ''; 
  const options: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: false }; // 24小时制格式化选项
  const timeString = date.toLocaleTimeString([], options);

  const year = date.getFullYear().toString(); // 年份
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份
  const day = date.getDate().toString().padStart(2, '0'); // 日期

  return `${year}年${month}月${day}日 ${timeString}`; // 显示年月日+时分
};

const getMonthReadableTime = (date:Date) : string =>{
    if(!date) return ''; 
    const options: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: false }; // 24小时制格式化选项
    const timeString = date.toLocaleTimeString([], options);
        // 如果都不是，显示月份日+时分
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份
    const day = date.getDate().toString().padStart(2, '0'); // 日期
    return `${month}月${day}日 ${timeString}`; // 显示月份日+时分
}

const getEasyReadTime = (date: Date): string => {
  if(!date) return '';
  const now = new Date();
  const options: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: false }; // 24小时制格式化选项
  const timeString = date.toLocaleTimeString([], options);

  // 检查是否是今天
  if (
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      date.getDate() === now.getDate()
  ) {
      return timeString; // 只显示时分
  }

  // 检查是否是本周
  const startOfWeek = new Date(now);
  startOfWeek.setDate(now.getDate() - (now.getDay() === 0 ? 6 : now.getDay() - 1)); // 本周的开始日期（周一）

  if (date >= startOfWeek && date < new Date(startOfWeek.getTime() + 7 * 24 * 60 * 60 * 1000)) {
      const weekDays = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];
      const weekDay = weekDays[date.getDay() === 0 ? 6 : date.getDay() - 1]; // 将星期日调整为数组索引6
      return `${weekDay} ${timeString}`; // 显示星期几+时分
  }

  // 如果都不是，显示月份日+时分
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份
  const day = date.getDate().toString().padStart(2, '0'); // 日期
  return `${month}月${day}日 ${timeString}`; // 显示月份日+时分
}; 


const getRoundNumber = (num:number):number=>{
   return Math.round(num);
}

const isEmpty = ( array : any []):boolean =>{
  if(array == null){
    return true;
  }
  if(array.length == 0){
    return true;
  }
  return false;
}

export const Util = {
    getFullDateReadableTime,
    getMonthReadableTime,
    getIdFromTime,
    stringCompareTo,
    numberCompareTo,
    booleanCompareTo,
    copyToClipboard,
    getEasyReadTime,
    getRoundNumber,
    isEmpty
}